module.exports = __webpack_public_path__ + "static/media/card-email-mobile-br.5d0a56bd.png";